<!--  CUSTOMER DETAILS  -->

<div class="customer-details">
	<!--  HEADING - MODE: NOT STARTED  -->

	<div *ngIf="mode === 'vehicle'" class="heading align-center">
		<h3 *ngIf="step_mode === 'full'">Enter your details to begin...</h3>
		<p *ngIf="step_mode === 'full'">
			We just need a few details in order to
			<br />
			create your personalised deal.
		</p>
		<h3 *ngIf="step_mode === 'reserve'">Reserve this vehicle now!</h3>
		<p *ngIf="step_mode === 'reserve'">
			Pay a small reservation fee to secure your
			<br />
			vehicle for complete peace of mind.
		</p>
		<h3 *ngIf="step_mode === 'part_exchange'">Enter your details to receive a valuation...</h3>
		<p *ngIf="step_mode === 'part_exchange'">
			We just need a few details in order to
			<br />
			begin the part exchange valuation process.
		</p>
	</div>

	<!--  END HEADING - MODE: NOT STARTED  -->

	<!--  HEADING - MODE: CUSTOMER DETAILS  -->

	<div *ngIf="mode === 'details'" class="heading align-center">
		<h3>Check your details...</h3>
		<p *ngIf="step_mode === 'full'">
			We'll need your details to get in touch
			<br />
			about your personalised deal.
		</p>
		<p *ngIf="step_mode === 'reserve' || (step_mode === 'part_exchange' && reserve_enabled)">
			We'll need your details to get in touch
			<br />
			about your reservation.
		</p>
		<p *ngIf="step_mode === 'part_exchange' && !reserve_enabled">
			We'll need your details to get in touch
			<br />
			about your part exchange valuation.
		</p>
	</div>

	<!--  END HEADING - MODE: CUSTOMER DETAILS  -->

	<!--  HEADING - MODE: SAVE FOR LATER  -->

	<div *ngIf="mode === 'save'" class="heading align-center">
		<h3>Save for later...</h3>
		<p *ngIf="step_mode === 'full'">
			We'll send you a link so you can revisit
			<br />
			your personalised deal at any time.
		</p>
		<p *ngIf="step_mode === 'reserve' || (step_mode === 'part_exchange' && reserve_enabled)">
			We'll send you a link so you can revisit
			<br />
			your reservation at any time.
		</p>
		<p *ngIf="step_mode === 'part_exchange' && !reserve_enabled">
			We'll send you a link so you can revisit
			<br />
			your part exchange valuation at any time.
		</p>
	</div>

	<!--  END HEADING - MODE: SAVE FOR LATER  -->

	<!--  CUSTOMER DETAILS FORM  -->

	<form [attr.name]="form_name" [formGroup]="customer_details_form" (submit)="onSubmit()" (input)="onFormInput($event)" class="form">
		<ui-text-control
			[form]="customer_details_form"
			[form_control]="customer_details_form.controls['first_name']"
			[type]="'text'"
			[label]="'Your First Name'"
			[placeholder]="'Enter your first name...'"
			[max_length]="50"
		></ui-text-control>

		<ui-text-control
			[form]="customer_details_form"
			[form_control]="customer_details_form.controls['last_name']"
			[type]="'text'"
			[label]="'Your Last Name'"
			[placeholder]="'Enter your last name...'"
			[max_length]="50"
		></ui-text-control>

		<ui-text-control
			[form]="customer_details_form"
			[form_control]="customer_details_form.controls['email']"
			[type]="'email'"
			[label]="'Your Email Address'"
			[placeholder]="'Enter your email address...'"
			[max_length]="255"
			[info]="getFieldInfo('email')"
			[highlighted_info]="true"
		></ui-text-control>

		<ui-text-control
			[form]="customer_details_form"
			[form_control]="customer_details_form.controls['tel_mob']"
			[type]="'tel'"
			[label]="'Your Mobile Number'"
			[placeholder]="'Enter your mobile number...'"
			[max_length]="50"
			[info]="getFieldInfo('tel_mob')"
			[highlighted_info]="true"
		></ui-text-control>

		<ui-checkbox-control
			*ngIf="mode === 'vehicle'"
			[form]="customer_details_form"
			[form_control]="customer_details_form.controls['terms']"
			[label]="
				'I agree to the ' +
				(dealer.terms_and_conditions_url ? '|Terms & Conditions*terms-and-conditions|, ' : '') +
				'|Terms of Use*terms-of-use| and |Privacy Policy*privacy-policy'
			"
			(cta)="onTermsCta($event)"
		></ui-checkbox-control>

		<button class="hidden">Submit</button>
		<a
			class="button block-button large-button positive-button"
			[class.loading]="loading"
			[attr.data-element-click]="'button__' + modal_name + '__positive-button[' + action_name + ']'"
			(click)="onSubmit()"
		>
			<span class="loading-spinner"></span>
			<span *ngIf="!loading">{{ action_name }}</span>
		</a>
		<div class="footer-logos">
			<ui-trust-logos [location]="'engage_configure_customer_details_modal'"></ui-trust-logos>
		</div>
	</form>

	<!--  END CUSTOMER DETAILS FORM  -->
</div>

<!--  END CUSTOMER DETAILS  -->
